import { Stack } from '@mui/material';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import DataCard, { DataCardCell, NameDescCell } from 'new/elements/DataCard';
import LightningStatus from 'new/elements/LightningStatus';
import Typography from 'new/elements/TypographySupport/TypographySupport';
import React from 'react';
import { ServiceKeyDetailHeaderMenu } from 'new/components/settings/Authentication/ServiceKeys/ServiceKeyDetailHeaderMenu';
import { DetailsIconButton } from 'new/elements/Button';

export function renderDataCardRow({ handleCardSelected, getData }) {
  return (index: number, item: { id: string | number }) => {
    const { cardData, name, description, createdAt, status } = getData(index);

    const key = item?.id ?? index;
    const onClickCard = () => handleCardSelected(cardData);

    return (
      <DataCard
        key={key}
        onClick={() => handleCardSelected(cardData)}
        rowsSlots={[
          <>
            <NameDescCell name={name} description={description} />
            <DataCardCell rightCTAsCell>
              <LightningStatus status={status} />
              <DetailsIconButton onClick={onClickCard} />
              <ServiceKeyDetailHeaderMenu data={cardData} />
            </DataCardCell>
          </>,
          <DataCardCell multiCol>
            <Stack spacing="8px" direction="row" alignItems="flex-end">
              <ChipWithCopy tooltipTitle="Copy Service Key ID" toCopy={cardData.id}>
                ID {cardData.id}
              </ChipWithCopy>
              <Typography variant="body3">
                <b>CREATED ON:</b> {createdAt}
              </Typography>
            </Stack>
          </DataCardCell>,
        ].filter(Boolean)}
      />
    );
  };
}
